<div class="custom-modal-layout">
  <div *ngIf="!pdfBlob" class="modal-form">
    <div class="modal-header" style="margin-bottom: 5px !important;">
      <div class="icon">
        <img src="icons/plus-circle.svg" alt="plus Icon" />
      </div>
      <span class="title">Novo Documento</span>
      <p-button icon="pi pi-times" class="close-btn" [rounded]="true" [text]="true" (onClick)="onCancel()" />
    </div>

    <form [formGroup]="form">
      <div class="p-fluid grid">
        <div class="field col-12 d-flex flex-column">
          <label for="tipoDocumento">Tipo de Documento</label>
          <p-select
            [filter]="true"
            appendTo="body"
            optionValue="id"
            [options]="TypeDocs"
            optionLabel="designacao"
            placeholder="Seleccione o tipo de documento"
            formControlName="tipoDocumento"
            (onChange)="onTypeChange($event)">
          </p-select>
          <small class="error-message" *ngIf="form.get('tipoDocumento')?.touched && form.get('tipoDocumento')?.invalid">
            Tipo de documento é obrigatório.
          </small>
        </div>
      </div>

      <!-- Um filho por vez (ngSwitch), mas ainda suportamos [disabled] vindo do pai -->
      <div [ngSwitch]="selectedType" class="p-fluid grid w-100 col-12">
        <app-oficio-instituicao-ensino
          class="w-100"
          *ngSwitchCase="1"
          [disabled]="!childEnabled"
          (formValueChanges)="handleChildEvent($event)"
          [documento]="form.value">
        </app-oficio-instituicao-ensino>

        <app-memorando-pagamento-de-subsidios-externos
          class="w-100"
          *ngSwitchCase="3"
          [disabled]="!childEnabled"
          (formValueChanges)="handleChildEvent($event)"
          [documento]="form.value">
        </app-memorando-pagamento-de-subsidios-externos>

        <app-declaracao-para-embaixada
          class="w-100"
          *ngSwitchCase="4"
          [disabled]="!childEnabled"
          (formValueChanges)="handleChildEvent($event)"
          [documento]="form.value">
        </app-declaracao-para-embaixada>

        <app-comprovativo-pagamento-de-subsidios
          class="w-100"
          *ngSwitchCase="6"
          [disabled]="!childEnabled"
          (formValueChanges)="handleChildEvent($event)"
          [documento]="form.value">
        </app-comprovativo-pagamento-de-subsidios>

        <app-cancelamento-bolsa
          class="w-100"
          *ngSwitchCase="8"
          [disabled]="!childEnabled"
          (formValueChanges)="handleChildEvent($event)"
          [documento]="form.value">
        </app-cancelamento-bolsa>

        <app-memorando-apoio-defesa-monografia
          class="w-100"
          *ngSwitchCase="9"
          [disabled]="!childEnabled"
          (formValueChanges)="handleChildEvent($event)"
          [documento]="form.value">
        </app-memorando-apoio-defesa-monografia>

        <app-ficha-de-cadastro
          class="w-100"
          *ngSwitchCase="5"
          [disabled]="!childEnabled"
          (formValueChanges)="handleChildEvent($event)"
          [documento]="form.value">
        </app-ficha-de-cadastro>
      </div>

      <div class="modal-footer">
        <button
          pButton
          type="button"
          label="Previsualizar"
          class="p-button-secondary"
          [disabled]="!canPreview"
          (click)="previewPDF()">
        </button>

        <button
          pButton
          type="button"
          label="Gerar Documento"
          class="p-button-primary"
          (click)="onSubmit()">
        </button>

        <button
          pButton
          type="button"
          label="Cancelar"
          class="p-button-outlined"
          (click)="onCancel()">
        </button>
      </div>
    </form>
  </div>
</div>
